module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.inspections.length) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "64px"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Inspection ID")]), _vm._v(" "), (_vm.showInspector) ? _c('th', [_vm._v("Forester Name")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Contact Name")]), _vm._v(" "), _c('th', [_vm._v("Region")]), _vm._v(" "), _c('th', [_vm._v("Created")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.inspections), function(inspection) {
    return _c('tr', {
      attrs: {
        "data-id": inspection.id
      },
      on: {
        "click": function($event) {
          _vm.onRowClick($event.target, inspection)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(inspection.id))]), _vm._v(" "), (_vm.showInspector && inspection.inspector.user.contact.first_name) ? _c('td', [_vm._v(_vm._s(inspection.inspector.user.contact.first_name) + " " + _vm._s(inspection.inspector.user.contact.last_name))]) : (_vm.showInspector) ? _c('td', [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v("N/A")])]) : _vm._e(), _vm._v(" "), (inspection.contact.first_name) ? _c('td', [_vm._v(_vm._s(inspection.contact.first_name) + " " + _vm._s(inspection.contact.last_name))]) : _c('td', [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v("N/A")])]), _vm._v(" "), (inspection.region) ? _c('td', [_vm._v(_vm._s(inspection.region.abbr))]) : _c('td', [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v("N/A")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(inspection.created_at.date, 'YYYY/M/D - HH:mm')))]), _vm._v(" "), _c('td', {
      staticClass: "status-badge-cell"
    }, [_c('inspection-status-badge', {
      attrs: {
        "inspection": inspection
      }
    })], 1), _vm._v(" "), (_vm.showDelete) ? _c('td', {
      staticClass: "text-right"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.onDeleteInspectionClick(inspection)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times push-5-r"
    }), _vm._v("Delete\n                    ")])]) : _vm._e()])
  }))])]) : _c('div', {
    staticClass: "row"
  }, [_vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "64px"
    }
  }, [_c('i', {
    staticClass: "icon-doc text-muted"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "text-center text-muted",
    staticStyle: {
      "padding-top": "60px"
    }
  }, [_c('p', [_c('i', {
    staticClass: "icon-ghost",
    staticStyle: {
      "font-size": "100px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("No inspections found.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vel nulla ac risus aliquam pellentesque. Quisque posuere nunc augue, nec posuere quam elementum quis.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70cde35e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/inspection-list.vue
// module id = 825
// module chunks = 3